import React from 'react';
import { ThemeToggle } from './ThemeToggle';
import { Button } from './Button';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="w-full py-4 px-6 md:px-12 flex items-center justify-between" data-id="element-287">
      <div className="flex items-center" data-id="element-288">
        <Link to="/home" className="flex items-center" data-id="element-289">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ov4W5y1TwYUNeHUCdRzqBe/Prepz.io_Logo_2.png" alt="Prepz.io Logo" className="h-28 w-auto" data-id="element-290" />
        </Link>
      </div>
      <nav className="hidden md:flex items-center space-x-8" data-id="element-291">
        <Link to="/home" className="text-[#F5F7FA] hover:text-[#C8F169] transition-colors" data-id="element-292">
          Home
        </Link>
        <Link to="/features" className="text-[#F5F7FA] hover:text-[#C8F169] transition-colors" data-id="element-293">
          Features
        </Link>
        <Link to="/pricing" className="text-[#F5F7FA] hover:text-[#C8F169] transition-colors" data-id="element-294">
          Pricing
        </Link>
        <Link to="/about" className="text-[#F5F7FA] hover:text-[#C8F169] transition-colors" data-id="element-295">
          About
        </Link>
      </nav>
      <div className="flex items-center space-x-4" data-id="element-296">
        <Link to="/authentication" className="text-[#F5F7FA] hover:text-[#C8F169] transition-colors" data-id="element-297">
          Login
        </Link>
        <Link to="/signup" data-id="element-298">
          <Button data-id="element-299">Sign Up</Button>
        </Link>
        <ThemeToggle data-id="element-300" />
      </div>
    </header>;
}